export default __webpack_public_path__ + "resources/icons/n330-ea1e.webp";